import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import BannerIcon from './BannerIcon';

export const BANNER_VARIANT_DEFAULT = 'default';
export const BANNER_VARIANT_PURPLE = 'purple';

const variantStyles = {
  [BANNER_VARIANT_DEFAULT]: {
    background: 'linear-gradient(to bottom, #ffffff, #f2f9fb)',
    border: '#3dc6f5',
    color: '#252525',
    closeButtonColor: '#3dc6f5',
    borderLeft: '#CFEAF1',
  },
  [BANNER_VARIANT_PURPLE]: {
    background: '#772def',
    border: '#772def',
    color: '#ffffff',
    closeButtonColor: '#ffffff',
    borderLeft: '#CFEAF1',
  },
}

const getVariantStyle = (variant) => variantStyles[variant] || variantStyles[BANNER_VARIANT_DEFAULT];

const BannerContainer = styled.div`
  display: flex;
  justify-content: space-between;
  background: ${({ variant }) => getVariantStyle(variant).background};
  border: 2px solid ${({ variant }) => getVariantStyle(variant).border};
  color: ${({ variant }) => getVariantStyle(variant).color};
  padding: 24px;
  border-radius: 8px;
  position: relative;
  .banner-left-container {
    // Any specific styles for banner-left-container
  }
  .banner-right-container {
    border-left: 1px solid ${({ variant }) => getVariantStyle(variant).borderLeft};
  }
`;

const CloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  color: ${({ variant }) => getVariantStyle(variant).closeButtonColor};
  font-size: 16px;
  cursor: pointer;
  font-weight: bold;
`;

export const Banner = ({ 
  show,
  variant, 
  onClose, 
  children, 
  icon,
  'data-mu-test': dataAttributeTest
}) => (
  show &&
  <BannerContainer variant={variant} data-mu-test={dataAttributeTest}>
    <BannerIcon>{icon}</BannerIcon>
    {children}
    <CloseButton onClick={onClose} variant={variant}>&times;</CloseButton>
  </BannerContainer>
);

Banner.propTypes = {
  show: PropTypes.bool.isRequired,
  variant: PropTypes.oneOf([BANNER_VARIANT_PURPLE, BANNER_VARIANT_DEFAULT]),
  onClose: PropTypes.func,
  children: PropTypes.node.isRequired,
  icon: PropTypes.node,
  'data-mu-test': PropTypes.string
};
